import React from 'react';

import { IframeBlock } from '../../_components/IframeBlock';
import { IframeBlockProps } from './types';

import classes from './index.module.scss';

export const IframeBlockGraphQL: React.FC<IframeBlockProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <IframeBlock iframeBlock={props} />
    </div>
  );
};

export default IframeBlockGraphQL;
